import styled from 'styled-components';
//
import colors from 'theme/colors';

export default styled.div`
  padding: 3px 72px;
  background-color: ${colors.white};
`;
